var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",class:_vm.b(),on:{"click":_vm.handleClick}},[_c('div',{ref:"box",class:_vm.b('box')},[_c('a',{ref:"text",class:_vm.b('text'),style:([_vm.styleName,_vm.styleSizeName]),attrs:{"href":_vm.linkHref,"target":_vm.linkTarget}},[_vm._v(_vm._s(_vm.dataChart.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }